import { Box, Button, Typography } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import React from "react";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { makeStyles } from "@material-ui/core/styles";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        background: "rgba(2, 51, 101, 0.1)",
        borderRadius: "0 " + theme.spacing(1) + "px 0 0",
        fontSize: "12px",
        minHeight: theme.spacing(8),
        padding: theme.spacing(2, 3),
        textAlign: "inherit",
    },
    img: {
        maxHeight: theme.spacing(3),
        height: "auto",
        width: "100%",
        maxWidth: theme.spacing(3),
        marginRight: theme.spacing(1),
        verticalAlign: "middle",
    },
    title: {
        color: theme.typography.subtitle1.color,
        fontSize: "14px",
    },
    container: {
        marginLeft: theme.spacing(3),
        width: "60%",
    },
    singleContainer: {
        marginLeft: theme.spacing(3),
        width: "100%",
        minHeight: theme.spacing(8),
    },
}); });
export var ButtonHeader = function () {
    var _a = useCheckoutContext(), _b = _a.checkoutSection.header, title = _b.title, TitleImg = _b.titleImg, _c = _b.hideChangePaymentMethod, hideChangePaymentMethod = _c === void 0 ? false : _c, _d = _a.handlers, setCheckoutSection = _d.setCheckoutSection, setKpaySelected = _d.setKpaySelected, closeErrorNotification = _d.closeErrorNotification;
    var classes = useStyles();
    var handleSet = function () {
        closeErrorNotification();
        setKpaySelected(undefined);
        setCheckoutSection(configCardSections.paymentMethods);
    };
    return (React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" }, hideChangePaymentMethod ? (React.createElement(Box, { className: classes.singleContainer, display: "flex", alignItems: "center" },
        TitleImg && React.createElement(TitleImg, { className: classes.img }),
        React.createElement(Typography, { className: classes.title },
            React.createElement(T, { id: title })))) : (React.createElement(React.Fragment, null,
        React.createElement(Box, { className: classes.container },
            React.createElement(Box, { display: "flex", alignItems: "center" },
                TitleImg && React.createElement(TitleImg, { className: classes.img }),
                React.createElement(Typography, { className: classes.title },
                    React.createElement(T, { id: title })))),
        React.createElement(Button, { className: classes.button, onClick: handleSet },
            React.createElement(T, { id: "cardSection.buttonText" }))))));
};
export default ButtonHeader;
